import queryString from 'query-string';

/**
 * @param {string} url Required, e.g. *\/en-gb\/account\/login?locale=en-gb&redirect=%2Fen-gb%2Faccount%3Flocale%3Den-gb*.
 * @param {string} fromLocale Required, e.g. *en-gb*.
 * @param {string} toLocale Required, e.g. *fr-fr*.
 */
const getUrlWithSwitchedLocale = (url, fromLocale, toLocale, redirectParams) => {
    fromLocale = fromLocale.trim().toLowerCase();
    toLocale = toLocale.trim().toLowerCase();

    const { url: relativeUrl, query: queryObj } = queryString.parseUrl(url);

    const newQueryObj = { ...queryObj, ...redirectParams };

    // Update locale in the relative URL
    // Locale following slash or beginning of the string
    // Locale followed by slash, ?, # or end of the string
    const regex = new RegExp(`(^|\\/)(${fromLocale})($|\\/|\\?|#)`, 'igm');
    const newRelativeUrl = relativeUrl.replace(regex, `$1${toLocale}$3`);

    // Update locale and redirect query parameters
    // Query parameter names are case-sensitive
    let newQuery = '';
    const hasQuery = Object.keys(newQueryObj).length > 0;
    if (hasQuery) {
        const { locale, redirect: redirectUrl } = newQueryObj;
        if (locale) {
            newQueryObj.locale = toLocale;
        }
        if (redirectUrl) {
            newQueryObj.redirect = getUrlWithSwitchedLocale(redirectUrl, fromLocale, toLocale);
        }
        newQuery = `?${queryString.stringify(newQueryObj)}`;
    }

    return `${newRelativeUrl}${newQuery}`;
};

export default getUrlWithSwitchedLocale;
